import { render, staticRenderFns } from "./Slide2.vue?vue&type=template&id=21f5cd41&scoped=true&"
import script from "./Slide2.vue?vue&type=script&lang=js&"
export * from "./Slide2.vue?vue&type=script&lang=js&"
import style0 from "./Slide2.vue?vue&type=style&index=0&id=21f5cd41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5cd41",
  null
  
)

export default component.exports